import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import _ from 'lodash';
import useFormValidator from 'useFormValidator';
import { ModalContext } from 'App';
import { customStyle } from 'helper';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../action';
import * as c from '../constant';

const statusOptions = [
  { label: 'SINGLE', value: 'SINGLE' },
  { label: 'PARTNERSHIP', value: 'PARTNERSHIP' },
  { label: 'CORPORATION', value: 'CORPORATION' },
];

function CreateModal({
  createMachineryOwner,
  formData,
  setFormData,
  getMachineryOwnerList,
  history,
  getSingleMachineryOwner,
  getRegionList,
  getProvinceList,
  getMunicipalityList,
  getBarangayList,
  regionList,
  provinceList,
  municipalityList,
  barangayList,
}) {
  const rules = {
    first_name: 'required',
    middle_name: 'required',
    last_name: 'required',
    status: 'required',
    authorized_representative: 'required_if:status=CORPORATION',
    region_code: 'required',
    province_code: 'required',
    municipality_code: 'required',
    barangay_code: 'required',
    address_line: 'required',
    tin: 'required|tin_no',
    telephone_no: 'required|tel_number',
    mobile_number: 'cellphone_number_+639',
    email: 'email',
  };

  const validateForm = useFormValidator(formData, rules);

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };
  const handleSelected = (key) => (e) => {
    if (key === 'status' && e.value !== 'CORPORATION') {
      setFormData({
        ...formData,
        authorized_representative: '',
      });
    }
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const getSelectedOptions = (list, value) => {
    return createDropdown(list).find((x) => x.value === value) || {};
  };

  const handleRegionSelect = (e) => {
    setFormData({
      ...formData,
      region_code: e.value,
      province_code: '',
      municipality_code: '',
      barangay_code: '',
    });
    getProvinceList({ region_code: e.value });
  };

  const handleProvinceSelect = (e) => {
    setFormData({
      ...formData,
      province_code: e.value,
      municipality_code: '',
      barangay_code: '',
    });
    getMunicipalityList({ province_code: e.value });
  };

  const handleMunicipalitySelect = (e) => {
    setFormData({
      ...formData,
      municipality_code: e.value,
      barangay_code: '',
    });
    getBarangayList({ municipality_code: e.value, display_all: 1 });
  };

  const handleBarangaySelect = (e) => {
    setFormData({
      ...formData,
      barangay_code: e.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
    };
    createMachineryOwner(args, ({ data }) => {
      setModal({ isOpen: false });
      getMachineryOwnerList();
      history.push(`/rpt/machinery/machinery-owner/${_.get(data, 'id')}`);
      getSingleMachineryOwner(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getRegionList();
  }, []);

  useEffect(() => {
    getProvinceList({
      region_code: _.get(formData, 'region_code'),
    });
  }, []);

  useEffect(() => {
    getMunicipalityList({
      province_code: _.get(formData, 'province_code'),
    });
  }, []);

  useEffect(() => {
    getBarangayList({
      municipality_code: _.get(formData, 'municipality_code'),
    });
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-6 form-group">
            <label htmlFor="first_name" className="form-label mb-0">
              First Name &nbsp; {validateForm.renderMessage('first_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="first_name"
              onChange={onChange}
              value={_.get(formData, 'first_name') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="middle_name" className="form-label mb-0">
              Middle Name &nbsp; {validateForm.renderMessage('middle_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="middle_name"
              onChange={onChange}
              value={_.get(formData, 'middle_name') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Last Name &nbsp; {validateForm.renderMessage('last_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="last_name"
              onChange={onChange}
              value={_.get(formData, 'last_name') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="suffix" className="form-label mb-0">
              Suffix
            </label>
            <input
              className="form-control"
              type="text"
              name="suffix"
              onChange={onChange}
              value={_.get(formData, 'suffix') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="status" className="form-label">
              Status &nbsp; {validateForm.renderMessage('status')}
            </label>
            <Select
              options={statusOptions}
              styles={customStyle}
              placeholder="-Select-"
              value={statusOptions.find(
                (item) => item.value === _.get(formData, 'status')
              )}
              onChange={handleSelected('status')}
            />
          </div>
          {formData?.status !== 'CORPORATION' && (
            <div className="col-6 form-group" />
          )}
          {formData?.status === 'CORPORATION' && (
            <div className="col-6 form-group">
              <label
                htmlFor="authorized_representative"
                className="form-label mb-0"
              >
                Authorized Representative &nbsp;{' '}
                {validateForm.renderMessage('authorized_representative')}
              </label>
              <input
                className="form-control"
                type="text"
                name="authorized_representative"
                onChange={onChange}
                value={_.get(formData, 'authorized_representative') || ''}
              />
            </div>
          )}
          <div className="col-6 form-group">
            <label htmlFor="region_code" className="form-label">
              Region &nbsp; {validateForm.renderMessage('region_code')}
            </label>
            <div>
              <Select
                value={getSelectedOptions(regionList, formData.region_code)}
                styles={customStyle}
                placeholder="Select Region"
                options={createDropdown(regionList)}
                onChange={(e) => {
                  handleRegionSelect(e);
                }}
              />
            </div>
          </div>
          <div className="col-6 form-group">
            <label className="form-label">
              Province &nbsp; {validateForm.renderMessage('province_code')}
            </label>
            <div>
              <Select
                value={getSelectedOptions(provinceList, formData.province_code)}
                styles={customStyle}
                placeholder="Select Province"
                options={createDropdown(provinceList)}
                onChange={(e) => {
                  handleProvinceSelect(e);
                }}
                isDisabled={!formData.region_code}
              />
            </div>
          </div>
          <div className="col-6 form-group">
            <label className="form-label">
              Municipality &nbsp;{' '}
              {validateForm.renderMessage('municipality_code')}
            </label>
            <div>
              <Select
                options={createDropdown(municipalityList)}
                styles={customStyle}
                placeholder="Select Municipality"
                value={getSelectedOptions(
                  municipalityList,
                  formData.municipality_code
                )}
                onChange={(e) => {
                  handleMunicipalitySelect(e);
                }}
                isDisabled={!formData.province_code}
              />
            </div>
          </div>
          <div className="col-6 form-group">
            <label className="form-label">
              Barangay &nbsp; {validateForm.renderMessage('barangay_code')}
            </label>
            <div>
              <Select
                options={createDropdown(barangayList)}
                styles={customStyle}
                placeholder="Select Barangay"
                value={getSelectedOptions(barangayList, formData.barangay_code)}
                onChange={(e) => {
                  handleBarangaySelect(e);
                }}
                isDisabled={!formData.municipality_code}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label htmlFor="address_line" className="form-label">
              Unit No. / House No. / Street Name &nbsp;{' '}
              {validateForm.renderMessage('address_line')}
            </label>
            <input
              className="form-control"
              type="text"
              name="address_line"
              onChange={onChange}
              value={_.get(formData, 'address_line') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="tin" className="form-label mb-0">
              Tax Identification Number &nbsp;{' '}
              {validateForm.renderMessage('tin')}
            </label>
            <InputMask
              className="form-control"
              mask="999-999-999-999"
              alwaysShowMask={false}
              type="text"
              name="tin"
              onChange={onChange}
              value={_.get(formData, 'tin') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="telephone_no" className="form-label mb-0">
              Telephone Number {validateForm.renderMessage('telephone_no')}
            </label>
            <InputMask
              className="form-control"
              mask="99-9999-9999"
              alwaysShowMask={false}
              type="text"
              name="telephone_no"
              onChange={onChange}
              value={_.get(formData, 'telephone_no') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="mobile_number" className="form-label mb-0">
              Mobile Number {validateForm.renderMessage('mobile_number')}
            </label>
            <InputMask
              className="form-control"
              mask="+639999999999"
              type="text"
              name="mobile_number"
              onChange={onChange}
              value={_.get(formData, 'mobile_number') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="email" className="form-label mb-0">
              Email Address
            </label>
            <input
              className="form-control"
              type="text"
              name="email"
              onChange={onChange}
              value={_.get(formData, 'email') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
            disabled={!validateForm.response.is_passed}
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getMachineryOwnerList: PropTypes.instanceOf(Function).isRequired,
  createMachineryOwner: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleMachineryOwner: PropTypes.instanceOf(Function).isRequired,
  getRegionList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  regionList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  municipalityList: PropTypes.instanceOf(Array).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  regionList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
